import { Map } from 'immutable';
// immutable has many good use cases. Read more at: https://immutable-js.github.io/immutable-js/
import { POPULATE_SUBPLAN_ASSIGNEE } from '@constants/actions';

const initialState = Map({
  subAssigneeList: [],
  subOrgList: [],
  totalCount: 0,
});

const SubscriptionPlanAssignee = (state = initialState, action: any) => {
  switch (action.type) {
    case POPULATE_SUBPLAN_ASSIGNEE: {
      const { data, totalCount } = action.payload;
      return state.set('subAssigneeList', data).set('totalCount', totalCount);
    }
    default:
      return state;
  }
};

export default SubscriptionPlanAssignee;
